import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Diagnóstico: exibe envs mascaradas para confirmar injeção pelo Vite
try {
  const maskedKey = supabaseAnonKey ? `${String(supabaseAnonKey).slice(0,6)}...(${String(supabaseAnonKey).length})` : 'undefined';
  // eslint-disable-next-line no-console
} catch (_) {}

// Se as variáveis não estiverem presentes, criamos um cliente de fallback
// para evitar quebra da aplicação em dev. A UI poderá exibir um erro amigável.
let supabase;
if (!supabaseUrl || !supabaseAnonKey) {

  const notConfigured = (method = 'operação') => ({
    data: null,
    error: {
      code: 'SUPABASE_NOT_CONFIGURED',
      message: `Supabase não configurado. Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY para usar ${method}.`
    }
  });

  const mockFromChain = {
    select: () => mockFromChain,
    eq: () => mockFromChain,
    order: () => mockFromChain,
    insert: async () => notConfigured('insert'),
    update: async () => notConfigured('update'),
    delete: async () => notConfigured('delete'),
    single: async () => notConfigured('consultas (single)'),
    maybeSingle: async () => notConfigured('consultas (maybeSingle)'),
  };

  supabase = {
    auth: {
      signInWithPassword: async () => notConfigured('login')
    },
    functions: {
      invoke: async () => notConfigured('functions.invoke')
    },
    from: () => mockFromChain
  };
} else {
  // Criação mínima e estável (SDK v2.x)
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      global: {
        fetch: (url, options = {}) => fetch(url, { ...options, credentials: 'omit' })
      }
    });
    
    // Configurar company_id no contexto do Supabase para RLS
    const user = JSON.parse(localStorage.getItem('astro_user_data') || '{}');
    if (user?.company_id) {
      supabase.rpc = supabase.rpc || {};
      // Definir variável de sessão para RLS
      supabase.auth.setSession = supabase.auth.setSession || function() {};
    }
  } catch (err) {
    console.error('Falha ao inicializar Supabase Client:', err);
    const notConfigured = (method = 'operação') => ({
      data: null,
      error: {
        code: 'SUPABASE_CLIENT_INIT_ERROR',
        message: `Supabase não pôde ser inicializado. Verifique VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY. (${method})`
      }
    });
    const mockFromChain = {
      select: () => mockFromChain,
      eq: () => mockFromChain,
      order: () => mockFromChain,
      insert: async () => notConfigured('insert'),
      update: async () => notConfigured('update'),
      delete: async () => notConfigured('delete'),
      single: async () => notConfigured('consultas (single)'),
      maybeSingle: async () => notConfigured('consultas (maybeSingle)'),
    };
    supabase = {
      auth: {
        signInWithPassword: async () => notConfigured('login')
      },
      functions: {
        invoke: async () => notConfigured('functions.invoke')
      },
      from: () => mockFromChain
    };
  }
}

export { supabase };
